import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";
import { TOKEN_KEY } from "../lib/mw";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

const TENANT_KEY = "mwcrm_tenant";
const YEAR_KEY = "mwcrm_year";

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=auth
  const [columns, setColumns] = useState([]);
  const [tenantInfo, setTenantInfo] = useState({ name: null, has_pin: false });
  const [perms, setPerms] = useState(null);

  if (typeof window !== "undefined" && !localStorage.getItem(YEAR_KEY)) {
    localStorage.setItem(YEAR_KEY, String(new Date().getFullYear()));
  }

  const loadColumns = async () => {
    try { const { data } = await api.get("/settings/columns", { silent: true }); setColumns(data); } catch (e) {}
  };
  const loadTenant = async () => {
    try { const { data } = await api.get("/tenant/info", { silent: true }); setTenantInfo(data); } catch (e) {}
  };
  const loadPerms = async () => {
    try { const { data } = await api.get("/my-permissions", { silent: true }); setPerms(data); } catch (e) { setPerms(null); }
  };

  useEffect(() => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) { setUser(false); return; }
    api.get("/auth/me", { silent: true })
      .then((r) => { setUser(r.data); loadColumns(); loadTenant(); loadPerms(); })
      .catch(() => setUser(false));
  }, []);

  const login = async (identifier, password, firm) => {
    const { data } = await api.post("/auth/login", { identifier, password, firm: firm || "" });
    localStorage.setItem(TOKEN_KEY, data.token);
    if (data.user.role === "super_admin") localStorage.removeItem(TENANT_KEY);
    setUser(data.user);
    await loadColumns();
    await loadTenant();
    await loadPerms();
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(TENANT_KEY);
    setUser(false);
  };

  const isSuperAdmin = !!user && user.role === "super_admin";
  const isAdmin = !!user && (user.role === "admin" || user.role === "super_admin");
  const selectedTenant = typeof window !== "undefined" ? (localStorage.getItem(TENANT_KEY) || "") : "";
  const year = typeof window !== "undefined" ? (localStorage.getItem(YEAR_KEY) || String(new Date().getFullYear())) : "";

  const setTenant = (tid) => {
    if (tid) localStorage.setItem(TENANT_KEY, tid); else localStorage.removeItem(TENANT_KEY);
    window.location.href = "/musteriler";
  };
  const setYear = (y) => { localStorage.setItem(YEAR_KEY, y); window.location.reload(); };

  return (
    <AuthCtx.Provider value={{ user, isAdmin, isSuperAdmin, login, logout, columns, loadColumns, tenantInfo, loadTenant, perms, loadPerms, selectedTenant, year, setTenant, setYear }}>
      {children}
    </AuthCtx.Provider>
  );
}
